/* Mantelly (27/09): sticky inteligente + botões de seção que compram o nível escolhido. */
(function () {
  function mainForm() {
    return document.querySelector('.product-form__submit.main-product-atc:not(.sticky-atc__add_button)')
      || document.querySelector('.product-form__submit[class*="featured-product-atc-"]');
  }
  // Botões de seção: [data-mt-atc] clica no ATC principal (mesmo nível marcado; com a compra direta, vai ao checkout)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mt-atc]');
    if (!b) return;
    e.preventDefault();
    var atc = mainForm();
    if (atc) { atc.click(); } else { window.location.href = b.getAttribute('href') || '#MainContent'; }
  });
  // Sticky: aparece quando o ATC principal não está na tela E nenhum card da oferta cruza os últimos 72 px
  // (mix & match 29/09: o painel "Pick a color for each item" conta como card, para o sticky não cobrir a última linha)
  function sticky() {
    var st = document.querySelector('sticky-atc.sticky-atc');
    var atc = mainForm();
    if (!st || !atc) return;
    var cards = document.querySelectorAll('.quantity-break, mt-mix-picker');
    var ticking = false;
    function check() {
      ticking = false;
      var vh = window.innerHeight, band = vh - 72;
      var a = atc.getBoundingClientRect();
      var atcOn = a.bottom > 0 && a.top < vh;
      var cardOn = false;
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        if (r.bottom > band && r.top < vh) { cardOn = true; break; }
      }
      st.classList.toggle('mt-sticky-off', atcOn || cardOn);
    }
    function onScroll() { if (!ticking) { ticking = true; setTimeout(check, 60); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
    setTimeout(check, 600);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sticky); else sticky();
})();

/* rev1: empurrão real do frete grátis (só com o nível avulso marcado) */
(function () {
  function sync() {
    var n = document.querySelector('[data-mt-nudge]');
    if (!n) return;
    var idInput = document.querySelector('form[id^="product-form"] input[name="id"]');
    n.hidden = !(idInput && idInput.value === n.getAttribute('data-mt-nudge'));
  }
  document.addEventListener('change', function () { setTimeout(sync, 120); });
  document.addEventListener('click', function (e) { if (e.target.closest('.quantity-break')) setTimeout(sync, 300); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();

/* rev4: o "Add" da sugestão do fim da PDP abre a gaveta (antes fazia POST e ia para /cart).
   Compra direta (07/10): com o motor ligado (window.mtDC) o botão é "Buy now" e o hcAddToCart leva ao checkout;
   se o add falhar, o erro aparece embaixo do botão (nada de ir para /cart). */
document.addEventListener('submit', function (e) {
  var f = e.target && e.target.closest && e.target.closest('form.mt-xsell');
  if (!f || !window.hcAddToCart) return;
  e.preventDefault();
  var b = f.querySelector('button');
  if (b && b.disabled) return;
  var old = f.querySelector('.mt-xsell__err');
  if (old) old.remove();
  if (b) b.disabled = true;
  window.hcAddToCart([{ id: Number(f.querySelector('[name="id"]').value), quantity: 1 }])
    .catch(function (err) {
      if (!window.mtDC || window.mtDirectCheckoutOff) { f.submit(); return; }
      var p = document.createElement('p');
      p.className = 'mt-xsell__err';
      p.setAttribute('role', 'alert');
      p.textContent = (err && err.message) || 'This item could not be added. Please try again.';
      (f.querySelector('.mt-xsell__row') || f).insertAdjacentElement('afterend', p);
    })
    .then(function () { if (b) b.disabled = false; });
});

/* Escadas (28/09): ao trocar estilo/tamanho, cada card do nível mostra a variante desse estilo (preço, 'de', SAVE,
   chips, legenda, selo e foto). O tema já busca a seção (?variant=&section_id=) e publica o HTML em variantChange;
   aqui cada card (label.quantity-break) recebe a classe e o conteúdo novos. O próprio tema só copia, por índice,
   o nome e o preço do card (.dynamic-price), que existem em todo card. */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  var SEL = '.product-form__input--quantity-breaks label.quantity-break';
  subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
    var d = e && e.data;
    if (!d || !d.html || !d.variant) return;
    var vss = document.querySelectorAll('variant-selects[data-has-quantity-breaks-picker="true"]');
    for (var j = 0; j < vss.length; j++) {
      var vs = vss[j];
      var sid = vs.dataset.originalSection || vs.dataset.section;
      if (String(sid) !== String(d.sectionId)) continue;
      if (vs.currentVariant && vs.currentVariant.id !== d.variant.id) continue;
      var src = d.html.getElementById('variant-selects-' + sid);
      if (!src) continue;
      var cur = vs.querySelectorAll(SEL), nw = src.querySelectorAll(SEL);
      if (!cur.length || cur.length !== nw.length) continue;
      for (var i = 0; i < cur.length; i++) {
        if (cur[i].className !== nw[i].className) cur[i].className = nw[i].className;
        if (cur[i].innerHTML !== nw[i].innerHTML) cur[i].innerHTML = nw[i].innerHTML;
      }
    }
  });
})();
